export default __webpack_public_path__ + "static/media/GeorgePortfolioUX.039c2b7a.pdf";